import React, {useCallback, useContext} from "react";
import {FaLink} from "react-icons/fa";
import {EditorContext, useEditorState} from "@tiptap/react";
import {toggleTextLink} from "./RichTextLinkExtension";

const RichTextLinkButton = () => {
    const {editor} = useContext(EditorContext);

    if (!editor || !editor.isEditable) return null;

    return <RichTextLinkButtonContent editor={editor}/>;
};

const RichTextLinkButtonContent = ({editor}) => {
    const isActive = useEditorState({
        editor,
        selector: ({editor}) => !!editor?.isActive("link"),
    });

    const handleClick = useCallback(event => {
        event.preventDefault();
        toggleTextLink(editor);
    }, [editor]);

    return (
        <button
            type="button"
            className={`rich-text-button${isActive ? " active" : ""}`}
            onMouseDown={event => event.preventDefault()}
            onClick={handleClick}
            title={isActive ? "Remover link (Ctrl+K)" : "Transformar texto em link (Ctrl+K)"}
            aria-label={isActive ? "Remover link" : "Transformar texto em link"}
        >
            <FaLink className="rich-text-button-icon"/>
        </button>
    );
};

export default RichTextLinkButton;
